import one from "./galleryImages/1.JPG";
import two from "./galleryImages/2.jpeg";
import three from "./galleryImages/3.JPG";
import four from "./galleryImages/4.JPG";
import five from "./galleryImages/5.jpeg";
import six from "./galleryImages/6.jpeg";
import seven from "./galleryImages/7.jpg";
import eight from "./galleryImages/8.jpeg";

export const images = [one, two, three, four, five, six, seven, eight];
